import { BasicDoctorInfo, DoctorsInBusiness } from "@elixir/types";
import { useDebounce } from "@elixir/utils";
import { useCallback, useEffect, useState } from "react";

const options = {
  location: 0,
  threshold: 0.3,
  distance: 100,
  keys: ["name"],
};

function SearchClinicDropdown({
  searchQuery,
  onSelectClinic,
  clinicsData,
}: {
  clinicsData: BasicDoctorInfo[];
  searchQuery: string;
  onSelectClinic: (patient: BasicDoctorInfo) => void;
}) {
  const [doctors, setDoctors] = useState<BasicDoctorInfo[]>([]);

  const debouncedInputValue = useDebounce(searchQuery, 300);

  const debouncedSearchFunction = useCallback(async () => {
    if (debouncedInputValue) {
      const Fuse = (await import("fuse.js")).default;
      const fuse = new Fuse(clinicsData, options);
      const response = fuse?.search(debouncedInputValue);
      const _data = response?.map(({ item }) => item);

      setDoctors(_data);
    } else {
      setDoctors(clinicsData);
    }
  }, [debouncedInputValue, clinicsData]);

  useEffect(() => {
    debouncedSearchFunction();
  }, [debouncedSearchFunction]);

  return (
    <div className="dr-flex dr-flex-col dr-border dr-border-darwin-neutral-50 dr-rounded-8">
      {doctors.map((item, index) => {
        return (
          <>
            <div
              onClick={() => onSelectClinic(item)}
              key={item.oid}
              className="dr-p-16 dr-flex dr-items-center dr-space-x-10 hover:dr-bg-darwin-neutral-50 focus:dr-bg-darwin-neutral-50 dr-cursor-pointer"
              role="button"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSelectClinic(item);
                }
              }}
              tabIndex={0}
            >
              <img
                className="dr-rounded-full dr-w-24 dr-h-24"
                src={item.pic}
                alt={item.name}
              />

              <div className="dr-flex dr-flex-col dr-space-y-8">
                <p className="BodyBold dr-text-darwin-neutral-1000">
                  {item.name}
                </p>
              </div>
            </div>
            {index < doctors.length - 1 ? (
              <div className="dr-h-1 dr-w-full dr-bg-darwin-neutral-200" />
            ) : (
              <></>
            )}
          </>
        );
      })}
    </div>
  );
}

export default SearchClinicDropdown;
